import { SSO } from "../../common/apiUrl/sso/ssoUrl";
import { API } from "../../common/model/objectTypes";
import { organizerUploadInfo } from "../../utils/apiDescription/sso/uploadOrganizer";
import { API_BASE_URL } from "../../utils/constants";
import { commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { batchRequestBody, proformaRequestBody } from "../../utils/sso/apiObjects";
import { batchJsonRequestCurl, proformaJsonRequestCurl } from "../../utils/sso/sampleJsonRequest";

const batch: API = {
    name: "Batch",
    url: `${API_BASE_URL}/${SSO.UPLOAD.BATCH_URL}`,
    method: "POST",
    headers: requestHeaderWithCallback,
    apiInfo: organizerUploadInfo.batch,
    requestBody: batchRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: batchJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const proforma: API = {
    name: "Proforma",
    url: `${API_BASE_URL}/${SSO.UPLOAD.PROFORMA_URL}`,
    method: "POST",
    headers: requestHeaderWithCallback,
    apiInfo: organizerUploadInfo.proforma,
    requestBody: proformaRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: proformaJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Batch':
            return batch;
        case 'Proforma':
            return proforma;
    }
}